export default __webpack_public_path__ + "static/media/icons-soc2-report.80f02cc8.svg";